import { useEffect, useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';

const useMultitabUuid = () => {
  const tabUuid = useMemo(() => {
    let existingTabUuid = sessionStorage.getItem('tabUuid');
    if (!existingTabUuid) {
      existingTabUuid = uuidv4();
      sessionStorage.setItem('tabUuid', existingTabUuid);
    }
    return existingTabUuid;
  }, []);

  useEffect(() => {
    const tabs = localStorage.getItem('activeTabs');
    const parsedTabs = tabs ? JSON.parse(tabs) : [];
    parsedTabs.push(tabUuid);
    localStorage.setItem('activeTabs', JSON.stringify(parsedTabs));

    const handleBeforeUnload = () => {
      const tabs = localStorage.getItem('activeTabs');
      if (tabs) {
        const parsedTabs = JSON.parse(tabs);
        const updatedTabs = parsedTabs.filter(
          (uuid: string) => uuid !== tabUuid,
        );
        localStorage.setItem('activeTabs', JSON.stringify(updatedTabs));
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [tabUuid]);
};

export default useMultitabUuid;
